import React from "react";
import { desk, fontMicro } from "./tokens";

/** A consistent framed panel. Title sits on the top border as a tab. */
const DeskPanel = ({ title, count, action, children, testid }) => (
  <section
    className="relative border mb-6"
    style={{ borderColor: desk.edge, backgroundColor: desk.surface }}
    data-testid={testid}
  >
    <header
      className="flex items-center justify-between gap-3 px-4 py-2.5 border-b"
      style={{ borderColor: desk.edge, backgroundColor: "rgba(255,255,255,0.015)" }}
    >
      <div className={`${fontMicro} flex items-center gap-2`} style={{ color: desk.inkDim }}>
        <span aria-hidden className="inline-block w-1 h-1" style={{ backgroundColor: desk.redact }} />
        {title}
        {typeof count === "number" && (
          <span style={{ color: desk.inkMuted }}>· {count.toString().padStart(2, "0")}</span>
        )}
      </div>
      {action}
    </header>
    <div className="p-4">{children}</div>
  </section>
);

export default DeskPanel;
